import * as R from 'ramda';
import { getNft, getNfts } from "../api";
import { Flex, Label } from "../style";
import { sizes, utils } from "../variables";
import { SUCCESSFUL_CREATION_CONTENT } from './constants';
import { AboutFlex, Section } from './style';

export const getApiNfts = async ({ address, loading, setLoading, setSnackbar }) => {
  if (loading) return;

  setLoading(true);
  try {
    const response = await getNfts(address);
    if (response.data) {
      const { nfts } = response.data;
      if (nfts) {
        const newResps = nfts.map(async ({ token_uri }) => {
          return getNft(token_uri)
            .then((res) => res.data)
            .catch((error) => {
              if (error && error.response) {
                const status = error.response.status;
                if (status === 403)
                  setSnackbar({
                    show: true,
                    content:
                      "Some of your NFTS are private and couldn't be accessed",
                    severity: "warning",
                  });
              }
            });
        });

        return Promise.all(newResps)
          .then((data) => data.filter((elem) => elem))
          .then((data) => {
            if (R.isEmpty(data)) {
              setLoading(false);
              return data;
            }
            setSnackbar({
              show: true,
              content: SUCCESSFUL_CREATION_CONTENT,
              severity: "success",
            });
            setLoading(false);
            return data;
          });
      }
    }
  } catch (error) {
    setSnackbar({
      show: true,
      content: UNABLE_TO_ACCESS_CONTENT,
      severity: "error",
    });
    setLoading(false);
  }
};

const About = () => {
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      width={utils.width.full}
      mt={sizes.md}
    >
      <Section>
        <AboutFlex>
          <Label fontSize={sizes.xl}>
            To Wallverse, <span className='highlight'>digital art</span> in Web3 is not only<span className="highlight"> what</span>, but also <span className="highlight">how</span> and <span className="highlight">where</span> it's being shared.
          </Label>
          <img src="/assets/about-upper-right.svg" alt="First example of nfts in a wall" />
        </AboutFlex>
      </Section>
      <Section>
        <AboutFlex reverse>
          <img src="/assets/about-upper-left.svg" alt="Second example of nfts in a wall" />
          <Label fontSize={sizes.xl}>
            We build tools that empower the NFT community to <span className="highlight">create, collect and share </span>new digital art experiences with Web3. <span className='highlight'>All in one place.</span>
          </Label>
        </AboutFlex>
      </Section>
      <Section>
        <AboutFlex>
          <Flex flexDirection="column" className="feedback-column">
            <Label fontSize={sizes.xl}>
              Feedback from <span className='highlight'>our community</span> is what matters most to us.
            </Label>
            <img src="/assets/about-lower-left.svg" className="middle-image" alt="Third example of nfts in a wall" />
            <Label fontSize={sizes.xl}>
              Help us build a better Wallverse for you! Answer a couple of questions <span className="link" onClick={() => window.open(process.env.REACT_APP_GOOGLE_FORMS, '_blank')}>clicking here.</span>
            </Label>
          </Flex>
          <img src="/assets/about-lower-left.svg" className="side-image" alt="Fourth example of nfts in a wall" />
        </AboutFlex>
      </Section>
    </Flex>
  );
};

export default About;
